<template>
    <!-- <span>{{ format.format(text || '') }}</span> -->
    <div v-if="row.__search"></div>
    <el-space v-else>
        <slot></slot>
        <template v-for="(item, index) in items" :key="index">
            <el-button v-bind="item" size="small" v-if="item.label" @click="handleClick(item)">{{
                    item.label
                }}
            </el-button>
            <el-button v-bind="item" size="small" v-else @click="handleClick(item)"></el-button>
        </template>
    </el-space>
</template>
<script>
import {inject} from 'vue'
import {computed} from 'vue'

export default {
    name: 'ActionColumn',
    props: {
        prop: {
            type: String,
            required: false,
        },
        row: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
        view: {
            type: Object,
            default: () => ({})
        },
        format: {
            type: Object,
            default: () => ({format: (v) => v})
        }
    },
    setup(props) {
        const text = computed(() => props?.row?.[props.prop] || '')
        const items = computed(() => props?.view?.items || [])
        const actionHandler = inject('actionHandler', () => {
        })
        const handleClick = (item) => {
            actionHandler(item, props.row)
        }
        return {
            text,
            items,
            handleClick
        }
    }
}
</script>
<style lang="scss">

</style>